import { render } from "./Modificar.vue?vue&type=template&id=1eb497c1"
import script from "./Modificar.vue?vue&type=script&lang=js"
export * from "./Modificar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__